// Instancia Axios con interceptor de auth (Google ID token). Ver CLAUDE.md §5/§12.
import axios from 'axios'
import { getToken, clearToken } from '@/googleAuth'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
})

// Adjunta el ID token de Google como Bearer.
api.interceptors.request.use((config) => {
  const t = getToken()
  if (t) config.headers.Authorization = `Bearer ${t}`
  return config
})

// 401 = token expirado/ inválido → limpiar para que la UI mande a login.
// Normaliza el error al formato { error, message } del backend.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) clearToken()
    const data = error?.response?.data
    return Promise.reject(data?.error ? data : { error: 'network_error', message: 'Error de red.' })
  },
)
